import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Col, Container, FloatingLabel, Form, Image, Row  } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import Category from './Category';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import * as RIcon from "react-icons/fa"
import { Link, useParams } from 'react-router-dom';
import AudioPlayer from './audio/AudioPlayer';
import Reply from './Reply';
import { Alert, Button } from '@mui/material';
import RegistOrLogin from './RegistOrLogin';
import ApiFetch from './ApiFetch';
import { LoginInfo } from '../App';
import CommonDialog from './common/CommonDialog';

const AudioView = () => {
    async function getStamp(userId,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/stamp/user/"+userId+"/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    let param = useParams()
    let groupId = param.id

    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)

    const [tabKey,setTabKey] = useState("")

    const [stampList,setStampList] = useState([])
    const [stampPage,setStampPage] = useState(0)
    const [stampMessage,setStampMessage] = useState("")
    const [stampOfficial,setStampOfficial] = useState(true)

    // 返信情報
    const [imageReplyPage,setImageReplyPage] = useState(0)
    const [imageReplyInfo,setImageReplyInfo] = useState([])

    useEffect(() => {
        if(stampPage > 0)
        getStamp(stampOfficial ? "bb37f7e5-7ea5-465a-8ae3-e6ac4bdd2341" : loginInfo.userId,stampPage).then(r => {
            if(r.result){
                setStampList(r.data)
                if(r.data.length === 0){
                    setStampMessage(<span>まだスタンプがありません。オリジナルのスタンプを登録してみませんか？：<Link to={"/stampManage"}>スタンプ管理</Link></span>)
                } else {
                    setStampMessage("")
                }
            }
        })
    },[stampPage,stampOfficial])

    useEffect(() => {
        const comment = imageReplyInfo.length > 0
        if(comment){
            setTabKey("comment")
        } else {
            setTabKey("comment")
        }
    },[imageReplyInfo])

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }
    const okButton = ""

    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Header />
        <Category />
        <CommonDialog open={show} onClose={() => setShow(false)} content={<><Alert severity='info'>{dialogTitle}</Alert><br />{dialogMessage}<br />{okButton}</>} fullScreen={false} />
        <Container className='w-100'>
            <Container className='text-center'>
                <AudioPlayer title={"テスト"} thumbnail={"/img/ourt_ai_logo.png"} views={120} likes={20} />
            </Container>
            <Container className='p-0' style={{border:"1px solid #CCCCCC",borderTop:"none"}}>
                <Row style={{display:"block",borderRadius:"5px",textAlign:"left",padding:"10px 5px",margin:"10px 0"}} className="w-100">
                    <Col xs={12} sm={12} md={12} lg={12} xl={8} xxl={12} style={{margin:"0 auto",width:"100%"}}>
                        <FloatingLabel
                        onClick={() => {
                            if(loginInfo.result === false){
                                dialog(t("common.loginToContinue"),<RegistOrLogin dialog={dialog} />)
                            }
                        }}
                        controlId="text" label="コメントを記載" className='mb-3 w-100' style={{lineHeight:"20px"}} onInput={(e) =>{
                            let lineHeight = e.currentTarget.style.lineHeight.replace(/[^0-9.]+/,'')
                            let n = e.nativeEvent.target.value.match(/\n/g)
                            if(n === null){
                                n = 1
                            } else {
                                n = n.length + 1
                            }
                            e.currentTarget.style.height = lineHeight * n + 30 + "px"
                            document.querySelector(".textarea").style.height = lineHeight * n + 30 + "px"
                        }}>
                            <Form.Control
                                className='textarea'
                                as="textarea"
                                style={{ width:"inherits",height: '50px' }}
                                required
                            />
                        </FloatingLabel>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={12} xl={8} xxl={12} style={{margin:"0 auto",width:"100%"}}>
                        <Button variant='outlined' onClick={() => {
                            if(stampList.length > 0){
                                setStampList([])
                                setStampPage(0)
                            } else {
                                setStampPage(1)
                            }
                        }}>
                        <RIcon.FaStamp style={{color:"#555555",cursor:"pointer",fontSize:"24px"}} /></Button>&nbsp;
                        <Button variant='outlined' onClick={() => {
                            if(loginInfo.result === false){
                                dialog(t("common.info"),<RegistOrLogin dialog={dialog} />)
                                return
                            }
                            let text = document.getElementById("text")
                            if(text.value.trim().length === 0){
                                dialog("エラー","コメントを入力して下さい。")
                                return
                            }
                            if(text.value.trim().length > 2500){
                                dialog("エラー","コメントは2500文字以内にして下さい。")
                                return
                            }
                            upload("image",document.getElementById("text").value,groupId)
                        }}>{t("common.comment")}</Button>
                        {stampMessage}
                        {stampList.length > 0 ? (
                        <Container style={{border:stampList.length > 0 ? "1px solid #555555" : "none",borderRadius:"5px"}} className='mt-2'>
                            <Button onClick={() => {
                                setStampOfficial(true)
                                setStampPage(1)
                            }} variant={stampOfficial ? 'contained' : "outlined"} className='m-3'>公式</Button>
                            <Button onClick={() => {
                                setStampOfficial(false)
                                setStampPage(1)
                            }} variant={!stampOfficial ? 'contained' : "outlined"} className='m-3'>保有</Button>
                            <Row>
                                <Col style={{display:stampList.length > 0 ? "block" : "none",margin:"0 auto"}} className="m-1">
                                    <Link to="/stampManage"><Icon.Plus style={{borderRadius:"5px",border:"3px solid #AAAAAA",fontSize:"64px",cursor:"pointer",width:"100px",height:"100px",margin:"0 auto"}} /></Link>
                                </Col>
                                {stampList.map((data,i) => {
                                    if(i === 30){
                                        return ""
                                    }
                                return <Col style={{margin:"0 auto"}} className="m-1" key={i}>
                                            <Container style={{position:"relative",width:"100px",height:"100px"}} className="p-0">
                                                {
                                                // <Badge bg="white" style={{cursor:"pointer",position:"absolute",backgroundColor:"#FFFFFF",padding:"5px",zIndex:1,top:"20px",right:"50px"}} onClick={() => navigate("/edit/"+data.group_id)}>
                                                //     <Icon.PencilSquare style={{color:"#000000"}} /> <span style={{color:"#555555"}}>編集</span>
                                                // </Badge>
                                                // <FavoriteIcon type="image" id={data.group_id} style={{cursor:"pointer",position:"absolute",zIndex:"1",bottom:"20px",right:"20px"}} favorite={data.favorite} dialog={dialog} />
                                                }
                                                <Image loading="lazy" src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/stamp/'+(data.stamp_id)+"_s"+ApiFetch.API_THUMB_EXT} style={{objectFit:"cover",position:"absolute",width:"100%",height:"100%",cursor:"pointer"}} className="stamp" 
                                                    onClick={() => {
                                                        upload("image",document.getElementById("text").value,groupId,data.stamp_id)
                                                        setStampList([])
                                                        setStampPage(0)
                                                    }}
                                                    onMouseOver={(e) => {
                                                        e.currentTarget.src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/stamp/'+(data.stamp_id)+ApiFetch.API_THUMB_EXT
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/stamp/'+(data.stamp_id)+"_s"+ApiFetch.API_THUMB_EXT
                                                    }}
                                                />
                                            </Container>
                                            <Container style={{fontWeight:"bold",fontSize:"15px"}}><Link to={"/image/"+(data.stamp_id)} style={{color:"#555555",textDecoration:"none"}}>{data.title}</Link></Container>
                                        </Col>
                                })}
                            </Row>
                            {stampList.length > 0 ? (
                            <Container className='d-flex justify-content-between' style={{width:"200px"}}>
                                {stampPage > 1 ? (
                                        <Button onClick={() => {
                                            let p = stampPage - 1
                                            setStampPage(p)
                                        } }>{t("common.prev")}</Button>
                                    ) : <Button disabled>{t("common.prev")}</Button>}
                                {stampList.length > 30 ? (
                                        <Button onClick={() => {
                                            let p = stampPage + 1
                                            setStampPage(p)
                                        } }>{t("common.next")}</Button>
                                    ) : <Button disabled>{t("common.next")}</Button>}
                            </Container>
                            ) : ""}
                        </Container>
                        ) : ""}
                    </Col>
                </Row>
                <Container>
                    {imageReplyInfo && imageReplyInfo.map((comment,i) => {
                        return (
                            <div key={i}>
                                <Reply postType="image" groupId={groupId} comment={comment} i={i} imageInfo={imageInfo} upload={upload} selectItem={selectItem} setOkButtonShow={setOkButtonShow} dialog={dialog} />
                                {comment.replyList.map((reply,j) => {
                                    return (<Reply postType="image" key={j} type={"reply-sub"} groupId={groupId} comment={reply} i={j} imageInfo={imageInfo} upload={upload} selectItem={selectItem} setOkButtonShow={setOkButtonShow} dialog={dialog} />)
                                })}
                            </div>
                        )
                    })}
                </Container>
            </Container>
        </Container>
        <Footer />
    </div>
    )
}

export default AudioView;
